module.exports = __webpack_public_path__ + "img/pwa-installed-award.7f528e10.png";